import { apiInstances } from '../../../../libs';

const { get } = apiInstances.ratingInstance;

export default async function getRatings({ idClouder }) {
  return get(`/ratings?idUser=${idClouder}`);
}
